module.exports = __webpack_public_path__ + "static/img/03.0f386b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/03.jpg
// module id = crWY
// module chunks = 1